import { validateEmail } from "../Login/Validation";

type data = {
  outletName: string;
  outletType: string;
  email: string;
  countryCode: string;
  phoneNumber: string;
  outletInfo: string;
  whatsappNumber: string;
  instaLink: string;
  fbLink: string;
  lat: string;
  long: string;
  address: string;
  shortName: string;
  tripAdvisor: string;
  maxGuest: string;
  venueId: string;
  sevenRoomWhatsapp: string;
  sevenRoomContact: string;
  logoUrl: string[];
  imageUrl: string[];
  bannerImageUrl: string[];
  iFrameUrl: string;
  isLoyaltyEnabled: boolean;
  posConfigtenderMediaLoyalty: string;
  posConfigUrl: string;
  posConfigempId: string;
  posConfigrevCenter: string;
  loyaltyTypes: string[];
  notificationEmail: string;
  surveyLink: string;
  receiptMerchantName: string;
  tags: string[];
  companyCode: string;
  costCenter: string;

  taxType: string;
  trn: string;
  tin: string;
  groupTrn: string;
  crNumber: string;

  taxStartDate: string;
  isInclusiveVAT: boolean;
  isTaxEnabled: boolean;
};

export const validateOutlet = (
  data: data,
  setError: (a: any) => void,
  isSevenRoomBooking: boolean,
  isIFrameBooking: boolean
) => {
  let isError = false;
  if (data.outletName === "") {
    setError((prevState: any) => ({
      ...prevState,
      outletName: "Please enter outlet name",
    }));
    isError = true;
  }
  if (data.outletType === "") {
    setError((prevState: any) => ({
      ...prevState,
      outletType: "Please select output type",
    }));
    isError = true;
  }
  if (data.email && !validateEmail(data.email)) {
    setError((prevState: any) => ({
      ...prevState,
      email: "Please enter valid email",
    }));
    isError = true;
  }
  if (data.phoneNumber && !checkIsPhoneNumber(data.phoneNumber)) {
    setError((prevState: any) => ({
      ...prevState,
      phoneNumber: "Please enter valid phone number",
    }));
    isError = true;
  }
  if (data.outletInfo === "") {
    setError((prevState: any) => ({
      ...prevState,
      outletInfo: "Please enter outlet information",
    }));
    isError = true;
  }
  if (data.lat === "") {
    setError((prevState: any) => ({
      ...prevState,
      lat: "Please add outlet lat",
    }));
    isError = true;
  } else if (!isValidLat(data.lat)) {
    setError((prevState: any) => ({
      ...prevState,
      lat: "Please add valid latitude",
    }));
    isError = true;
  }
  if (data.long === "") {
    setError((prevState: any) => ({
      ...prevState,
      long: "Please add outlet long",
    }));
    isError = true;
  } else if (!isValidLng(data.long)) {
    setError((prevState: any) => ({
      ...prevState,
      long: "Please add valid longitude",
    }));
    isError = true;
  }
  if (data.address === "") {
    setError((prevState: any) => ({
      ...prevState,
      address: "Please enter address",
    }));
    isError = true;
  }
  if (!isSevenRoomBooking) {
    if (data.sevenRoomWhatsapp && !checkIsPhoneNumber(data.sevenRoomWhatsapp)) {
      setError((prevState: any) => ({
        ...prevState,
        sevenRoomWhatsapp: "Please enter valid number",
      }));
      isError = true;
    }
    if (data.sevenRoomContact && !checkIsPhoneNumber(data.sevenRoomContact)) {
      setError((prevState: any) => ({
        ...prevState,
        sevenRoomContact: "Please enter valid number",
      }));
      isError = true;
    }
  }
  if (isSevenRoomBooking) {
    if (data.maxGuest === "") {
      setError((prevState: any) => ({
        ...prevState,
        maxGuest: "Please enter maximum guest limit",
      }));
      isError = true;
    } else if (!Number(data.maxGuest)) {
      setError((prevState: any) => ({
        ...prevState,
        maxGuest: "Please enter limit in number",
      }));
      isError = true;
    }
    if (data.venueId === "") {
      setError((prevState: any) => ({
        ...prevState,
        venueId: "Please enter the venue ID",
      }));
      isError = true;
    }
  }
  if (data.logoUrl.length === 0) {
    setError((prevState: any) => ({
      ...prevState,
      logoUrl: "Please upload outlet logo",
    }));
    isError = true;
  }
  if (data?.tags?.length === 0) {
    setError((prevState: any) => ({
      ...prevState,
      tags: "Please select atleast one tag",
    }));
    isError = true;
  }
  if (data.imageUrl.length === 0) {
    setError((prevState: any) => ({
      ...prevState,
      imageUrl: "Please upload outlet images (Maximum 5)",
    }));
    isError = true;
  }
  if (data.whatsappNumber && !checkIsPhoneNumber(data.whatsappNumber)) {
    setError((prevState: any) => ({
      ...prevState,
      whatsappNumber: "Please enter valid phone number",
    }));
    isError = true;
  }
  if (data.instaLink && !urlValidation(data.instaLink)) {
    setError((prevState: any) => ({
      ...prevState,
      instaLink: "Please enter valid instagram URL",
    }));
    isError = true;
  }
  if (data.fbLink && !urlValidation(data.fbLink)) {
    setError((prevState: any) => ({
      ...prevState,
      fbLink: "Please enter valid facebook URL",
    }));
    isError = true;
  }
  if (data.tripAdvisor && !urlValidation(data.tripAdvisor)) {
    setError((prevState: any) => ({
      ...prevState,
      tripAdvisor: "Please enter valid trip advisor URL",
    }));
    isError = true;
  }
  if (data.outletType === "2") {
    if (data.bannerImageUrl.length === 0) {
      setError((prevState: any) => ({
        ...prevState,
        bannerImageUrl: "Please upload banner image",
      }));
      isError = true;
    }
  }
  if (isIFrameBooking) {
    if (data.iFrameUrl === "") {
      setError((prevState: any) => ({
        ...prevState,
        iFrameUrl: "Please enter URL",
      }));
      isError = true;
    } else if (!urlValidation(data.iFrameUrl)) {
      setError((prevState: any) => ({
        ...prevState,
        iFrameUrl: "Please enter valid URL",
      }));
      isError = true;
    }
  } else if (data.iFrameUrl && !urlValidation(data.iFrameUrl)) {
    setError((prevState: any) => ({
      ...prevState,
      iFrameUrl: "Please enter valid URL",
    }));
    isError = true;
  }

  if (data?.surveyLink && !urlValidation(data.surveyLink)) {
    setError((prevState: any) => ({
      ...prevState,
      surveyLink: "Please enter valid URL",
    }));
    isError = true;
  }

  // if (data.costCenter === "") {
  //   setError((prevState: any) => ({
  //     ...prevState,
  //     costCenter: "Please enter cost center",
  //   }));
  //   isError = true;
  // }

  // if (data.companyCode === "") {
  //   setError((prevState: any) => ({
  //     ...prevState,
  //     companyCode: "Please enter company code",
  //   }));
  //   isError = true;
  // }

  if (data?.isLoyaltyEnabled) {
    if (data?.loyaltyTypes?.length < 1) {
      setError((prevState: any) => ({
        ...prevState,
        loyaltyTypes: "Please select atleast one loyalty type",
      }));
      isError = true;
    } else {
      if (data?.loyaltyTypes?.includes("pos")) {
        if (!data.posConfigUrl) {
          setError((prevState: any) => ({
            ...prevState,
            posConfigUrl: "Please enter URL",
          }));
          isError = true;
        }
        if (!data.posConfigempId) {
          setError((prevState: any) => ({
            ...prevState,
            posConfigempId: "Please enter Employee ID",
          }));
          isError = true;
        }
        if (!data.posConfigrevCenter.toString().trim()) {
          setError((prevState: any) => ({
            ...prevState,
            posConfigrevCenter: "Please enter revenue center",
          }));
          isError = true;
        }
        if (!data.posConfigtenderMediaLoyalty) {
          setError((prevState: any) => ({
            ...prevState,
            posConfigtenderMediaLoyalty: "Please enter tender media loyalty",
          }));
          isError = true;
        }
        if (data.notificationEmail && !validateEmail(data.notificationEmail)) {
          setError((prevState: any) => ({
            ...prevState,
            notificationEmail: "Please enter valid notification email",
          }));
          isError = true;
        }
      }
      if (data?.loyaltyTypes?.includes("scan")) {
        if (!data.receiptMerchantName) {
          setError((prevState: any) => ({
            ...prevState,
            receiptMerchantName: "Please enter merchant name",
          }));
          isError = true;
        }
      }
    }
  }

  return isError;
};

const checkIsPhoneNumber = (data: string) => {
  return /^\+?[0-9]{5,16}$/.test(data);
};

const isValidLat = (value: string) => {
  if (Number(value) >= -90 && Number(value) <= 90) {
    return true;
  }
};

const isValidLng = (value: string) => {
  if (Number(value) >= -180 && Number(value) <= 180) {
    return true;
  }
};

export const urlValidation = (data: string) => {
  // eslint-disable-next-line no-useless-escape
  return /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/.test(
    data
  );
};
